import { WalletSkeletonGrayBox } from "../../../../style/skeleton";
import WalletPubListSkeletonItem from "../pub-list-item/skeleton";
import { WalletPubListAreaItem, WalletPubListWrapper } from "./style";

const WalletPubListSkeleton = () => {
  return (
    <WalletPubListWrapper>
      {Array.from({ length: 3 }, (_, index) => (
        <WalletPubListAreaItem key={index}>
          <WalletSkeletonGrayBox />
          {Array.from({ length: index === 0 ? 1 : 5 }, (_, i) => (
            <WalletPubListSkeletonItem key={i} />
          ))}
        </WalletPubListAreaItem>
      ))}
    </WalletPubListWrapper>
  );
};

export default WalletPubListSkeleton;
